import { onInput } from '@nx-paeonia/utils-events';

export function maximumLengthHandler() {
  onInput(
    '.configurator-text-input[maxlength], .configurator-textarea-input[maxlength]',
    (_, element: HTMLInputElement | HTMLTextAreaElement) => {
      const maxLength = element.getAttribute('maxlength');
      const currentLength = getTextInputCurrentLength(element);
      const outputElement = element.parentElement?.querySelector('output');

      if (outputElement) {
        outputElement.textContent = `${currentLength}/${maxLength}`;
      }
    },
  );
}

/**
 * Decides the current length of the text input.
 *
 * Business logic if the input is a textarea enters should be counted as `\r\n` for each new line because the API stores
 * it this way.
 */
function getTextInputCurrentLength(inputElement: HTMLInputElement | HTMLTextAreaElement) {
  if (inputElement instanceof HTMLInputElement) {
    return inputElement.value.length;
  }

  // For textarea, count each new line as 2 characters (`\r\n`)
  const lines = inputElement.value.split('\n');
  let length = 0;

  lines.forEach((line, index) => {
    length += line.length;
    // Add 2 for each new line except the last one
    if (index < lines.length - 1) {
      length += 2;
    }
  });

  return length;
}
